/**
 * Created by manuel on 14/11/2016.
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { Contact, ContactsResponse } from '../../model/contact.class';
import { AccountService } from '../shell/account.service';
import { AuthService } from '../shell/auth.service';
import { SessionService } from '../shell/session.service';
import { APIAddressbookFilter, ContactSearchOptions, PaginatedAPIAddressbookContacts } from './contact-list.model';

const STORAGE_KEY_SEARCH_OPTION = 'contact_search_option';

@Injectable()
export class ContactListService {
  public currentContactList: Map<string, Contact[]>;
  private headers = new HttpHeaders({
    Authorization: 'Bearer ' + this.account.current.token,
    'Voverc-Jwt-Auth': this.account.current.jwtToken,
  });

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private account: AccountService,
    private session: SessionService
  ) {}

  sortContacts(list: Contact[]): Map<string, Contact[]> {
    const sorted = new Map<string, Contact[]>();
    const sortByName = function (a, b) {
      return a.firstName.toUpperCase() == b.firstName.toUpperCase()
        ? 0
        : +(a.firstName.toUpperCase() > b.firstName.toUpperCase()) || -1;
    };

    list.sort(sortByName);

    list.forEach((item) => {
      const firstLetter = String(item.firstName[0].toUpperCase());

      if (!sorted.get(firstLetter)) {
        const blank: Contact[] = [];
        sorted.set(firstLetter, blank);
      }

      sorted.get(firstLetter).push(item);
    });

    /**
     * Sort contacts per letter
     */
    for (const key in sorted) {
      sorted[key].sort();
    }

    return sorted;
  }

  getContacts(pbxId: number): Observable<ContactsResponse> {
    if (this.currentContactList) {
      return of(null);
    } else {
      return this.http.get(`${environment.API_URL}/api/v1/pbxes/${pbxId}/address-book`, { headers: this.headers }).pipe(
        map((response: ContactsResponse) => {
          const list = response.users;
          this.currentContactList = this.sortContacts(list);

          return null;
        })
      );
    }
  }

  public getSharedContacts(filters: APIAddressbookFilter): Observable<PaginatedAPIAddressbookContacts> {
    return this.http.post<PaginatedAPIAddressbookContacts>(`${environment.API_URL}/api/v2/contacts/search`, filters, {
      headers: this.headers.append('Voverc-Company-ID', String(this.session.current.companyId)),
    });
  }

  public loadSearchOptionFromStorage(searchOptions: ContactSearchOptions[]): ContactSearchOptions {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY_SEARCH_OPTION);
      if (stored) {
        const option = searchOptions.find((opt) => opt.label === stored);
        if (option) {
          return option;
        }
      }
    } catch (e) {
      console.error('Failed to load search option from storage:', e);
    }

    return searchOptions[0];
  }

  public saveSearchOptionToStorage(option: ContactSearchOptions): void {
    try {
      sessionStorage.setItem(STORAGE_KEY_SEARCH_OPTION, option.label);
    } catch (e) {
      console.error('Failed to save search option to storage:', e);
    }
  }
}
